"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeTitanDatabase = exports.initializeMoneyDatabases = void 0;
const validate_1 = require("./validate");
// Let's not over-engineer this. Keeping it explicit for easier readability - Classicus, Nov 23, 2021
function initializeMoneyDatabases(client) {
    return __awaiter(this, void 0, void 0, function* () {
        yield client.connect();
        const testnetDatabase = client.db('testnets');
        const prodnetDatabase = client.db('prodnets');
        yield (0, validate_1.enforceDatabaseTypes)([testnetDatabase, prodnetDatabase]);
        return {
            globals: {
                testnets: testnetDatabase.collection('globals'),
                prodnets: prodnetDatabase.collection('globals'),
            },
            ipfs: {
                testnets: testnetDatabase.collection('ipfs'),
                prodnets: prodnetDatabase.collection('ipfs'),
            },
            passports: {
                testnets: testnetDatabase.collection('passports'),
                prodnets: prodnetDatabase.collection('passports'),
            },
            signatures: {
                testnets: testnetDatabase.collection('signatures'),
                prodnets: prodnetDatabase.collection('signatures'),
            },
            score_statistics: {
                testnets: testnetDatabase.collection('score_statistics'),
                prodnets: prodnetDatabase.collection('score_statistics'),
            },
            scores: {
                testnets: testnetDatabase.collection('scores'),
                prodnets: prodnetDatabase.collection('scores'),
            },
            skins: {
                testnets: testnetDatabase.collection('skins'),
                prodnets: prodnetDatabase.collection('skins'),
            },
            pending_transactions: {
                testnets: testnetDatabase.collection('pending_transactions'),
                prodnets: prodnetDatabase.collection('pending_transactions'),
            },
        };
    });
}
exports.initializeMoneyDatabases = initializeMoneyDatabases;
function initializeTitanDatabase(client) {
    return __awaiter(this, void 0, void 0, function* () {
        yield client.connect();
        return {
            titan_scores: {
                testnets: client.db('staging_scores'),
                prodnets: client.db('prod_scores'),
            },
            titan_discord: {
                testnets: client.db('staging_discord'),
                prodnets: client.db('prod_discord'),
            },
        };
    });
}
exports.initializeTitanDatabase = initializeTitanDatabase;
__exportStar(require("./models"), exports);
//# sourceMappingURL=index.js.map